const PortadaHistoria = (props) => {
  const { textoHistoria,  elementoIntroHistoria } = props;
  const { titulo, ciudad, departamento, convocatoria, imagen } = textoHistoria;
  return (
    <div className="h-screen bg-verde-portada relative">
      <div className={`h-full img-cover-bottom`}
        style={{
        backgroundImage: 'url(' +require(`../../images/ilustraciones/${imagen}`).default + ')'
      }}
      />

      <div className="absolute bottom-0 fondo-portada-historia center w-full h-96 lg:h-80 ">
        <div className="text-center w-10/12 mt-20 md:mt-14 md:w-8/12">
          <h1 className="poppins-700 text-24 md:text-30">{titulo}</h1>
          <p className="poppins-300 text-20">{ciudad}, {departamento} / Convocatoria {convocatoria} </p>
          <button
            className="text-28 text-rosado mt-5 lg:mt-5 "
            onClick={() => {
              let link =  elementoIntroHistoria.current;
              document.getElementsByTagName('html')[0].scrollTop = link.offsetTop;                 
            }}
          >
            <p className="poppins-700 leading-none ">Leer</p>
            <span className="icon-abajo"></span>
          </button>
        </div>
      </div>
      
    </div>
  )
}

export default PortadaHistoria;